/* eslint-disable react/prop-types */
import React, {useEffect} from 'react';
import removeWhiteSpace from '../../constants/removeSpace';
import {CBForm} from '../../constants/apricotCBform';
import '../SmartDisplay/SmartDisplay.scss';
import {ToolTip} from '../';
import { lockMsg, lockMsgAdmin } from '../../constants/messages';
import { ADMIN_ROLE } from '../../constants/global';

const NumberInput = props => {

  const {apcp, question_tooltip, inputId, halfInput, inputType, inputLabel, requiredInput,
    inputName, textvalue, org_rol, errorId, onChangeInputValue,
    successMsg='Success', errMsg='Error', minN, maxN, readOnly, showQlock, children} = props;

  useEffect(() => {
    document.querySelectorAll('.cb-floating-label').forEach(elem => {
      CBForm.floatingLabel(elem.querySelector('input'));
    });
  }, []);

  return(
    <div id={`${errorId}_one`} className='fieldArrangement'>
      <div className='cb-input cb-input-condensed col-md-12 fieldInput'>
        <div id={`${errorId}_two`} className='cb-validation-label-input'>

          <div className={`display-flex ${halfInput?'col-md-12':'col-md-6'}`} >
            {children}
            <label className={`${requiredInput?'cb-required':''}`} htmlFor={`num`+removeWhiteSpace(inputId)}>{inputLabel}</label>
            {
              !apcp&&question_tooltip?<ToolTip tooltipid={`smartdisplaynumbers${removeWhiteSpace(inputId)}id`} 
                                        tooltipMsg={question_tooltip} 
                                        innerMsg={<span className="cb-icon cb-user"></span>} 
                                        className={'questionToolTip'}
                                        />
                                        :''
            }
          </div>

          <div className={`lineupinput ${halfInput?'col-md-12':'col-md-6'}`}>
            <input type='text' id={`num`+removeWhiteSpace(inputId)}
              name={inputName}
              className='opentextinput'
              value={textvalue}
              autoComplete='off'
              aria-invalid='false'
              disabled={readOnly}
              aria-readonly={readOnly}
              aria-required={requiredInput}
              data-testid={inputId}
              min={minN}
              max={maxN}
              onKeyPress={event=>{
                var theEvent = event || window.event;
                // Handle paste
                if (theEvent.type === 'paste') {
                    key = theEvent.clipboardData.getData('text/plain');
                } else {
                // Handle key press
                    var key = theEvent.keyCode || theEvent.which;
                    key = String.fromCharCode(key);
                }
                var regex = /[0-9]|\./;
                if( !regex.test(key) ) {
                  theEvent.returnValue = false;
                  if(theEvent.preventDefault) theEvent.preventDefault();
                }
              }}
              onChange={event => {
                onChangeInputValue(event.target.value);
              }} />
              {showQlock?
                <ToolTip tooltipid={`numbertooltip${inputId}`} tooltipMsg={org_rol===ADMIN_ROLE?lockMsgAdmin:lockMsg}
                className={'cb-icon cb-lock'} />:''
              }
          </div>
        </div>
      </div>
      <div className='errorDiv'>
        <p id={`${errorId}_s`} style={{display: 'none'}}>{successMsg}</p>
        <p id={`${errorId}_e`} style={{display: 'none'}}>{errMsg}</p>
      </div>
    </div>
  );
};

export default NumberInput;